<template>
  <div class="clearfix">
    <div class="corporate_container clearfix">
      <slot name="info"></slot>
    </div>

    <!-- Current shareholders -->
    <div class="current_shareholders">
      <title-temp title="Current shareholders"></title-temp>
      <table-list :column="currentColumn" :tableData="currentData" ></table-list>
      <div class="table_pagegation">
        <span class="total_text">Total {{totalCurrent}} records</span>

        <el-pagination
          @current-change="CurrentChange"
          background
          :current-page="pageCurrent"
          :page-sizes="[10]"
          :pager-count="5"
          layout="prev, pager, next"
          :total="totalCurrent"
        ></el-pagination>
      </div>
    </div>

    <!-- Shareholders history   -->
    <div class="shareholders_history">
      <title-temp title="Shareholders history"></title-temp>
      <table-list :column="shareholderColumn" :tableData="shareholderData"></table-list>
      <div class="table_pagegation">
        <span class="total_text">Total {{totalHistory}} records</span>

        <el-pagination
          @current-change="HistoryChange"
          background
          :current-page="pageHistory"
          :page-sizes="[10]"
          layout="prev, pager, next"
          :pager-count="5"
          :total="totalHistory"
        ></el-pagination>
      </div>
    </div>

    <!-- Shareholders history   -->
    <div class="current_subsidiaries">
      <title-temp title="Current subsidiaries"></title-temp>
      <table-list :column="subsidiaryColumn" :tableData="subsidiaryData" ></table-list>
    </div>

    <!-- Branches 无数据暂时隐藏-->
    <!-- <div class="branches">
      <title-temp title="Branches"></title-temp>
      <table-form :columnData="branchesColumn" :tableData="branchesData"></table-form>
    </div>-->
  </div>
</template>

<script>
import TableList from "common/components/table";
import TableForm from "common/components/tableForm";
import TitleTemp from "common/components/Title";
import {
  getBasic,
  getCorporateShareHolders,
  getShareHoldersPage
} from "common/js/http/v2Api";

import {
  currentColumn,
  shareholderColumn,
  subsidiaryColumn,
  branchesColumn
} from "conf/Corporate";

export default {
  components: {
    TableList,
    TitleTemp,
    TableForm
  },

  data() {
    return {
      id: this.$route.query.id,
      code: this.$route.query.code,
      exchangeInfo: "",

      currentColumn,
      currentData: [],

      shareholderColumn,
      shareholderData: [],

      subsidiaryColumn,
      subsidiaryData: [],

      branchesColumn,
      branchesData: { a: "branches" },

      // pageInfo  Current History
      pageHistory: 1,
      pageCurrent: 1,
      totalHistory: 0,
      totalCurrent: 0
    };
  },

  created() {
    this.getExchangeInfo();
  },

  methods: {
    // 获取交易所信息
    async getExchangeInfo() {
      const { result } = await getBasic(this.id, this.code);

      this.exchangeInfo = result["Key information"].stock_exchange_listed;
      this.getShareHolds(this.exchangeInfo);
    },

    // 获取全部信息
    async getShareHolds(exchangeName) {
      const params = {
        bvdId: this.id,
        exchangeName,
        page: 1,
        size: 10,
        stockCode: this.code
      };
      const { result } = await getCorporateShareHolders(params);
      this.currentData = result[1] && result[1].val.recordList;
      this.totalCurrent = result[1] && result[1].val.recordCount;

      this.shareholderData = result[0] && result[0].val.recordList;
      this.totalHistory = result[0] && result[0].val.recordCount;
    },

    //获取分页信息  dataType 0:历史    1:当前
    async getPageInfo(dataType, page) {
      const params = {
        bvdId: this.id,
        exchangeName: this.exchangeInfo,
        dataType,
        page,
        size: 10,
        stockCode: this.code
      };

      const { result } = await getShareHoldersPage(params);
      return result.recordList;
    },

    async HistoryChange(val) {
      this.pageHistory = val;
      this.shareholderData = await this.getPageInfo("0", this.pageHistory);
    },

    async CurrentChange(val) {
      this.pageCurrent = val;
      this.currentData = await this.getPageInfo("1", this.pageCurrent);
    }
  }
};
</script>